<template>
  <nxt-core-card :class="$setClasses"
                 :title="field.title"
                 icon="calculator">
    <nxt-core-html-content>
      <template v-if="field.before_content"
                v-slot:beforeContent>
        <div v-html="field.before_content"/>
      </template>
      <div :class="$vClass('main')">
        <template v-for="(item, index) in contentMinarmRights"
                  :key="index">
          <nxt-core-card :class="[$vClass('card'), item.modifiers]">
            <div :class="[$vClass('card__content')]">
              <h2 :class="$vClass('card__content__title')">
                {{ item.title }}</h2>
              <p :class="$vClass('card__content__price')">
                {{ item.value }}
              </p>
            </div>
          </nxt-core-card>
        </template>
      </div>
      <template v-if="field.after_content"
                v-slot:afterContent>
        <div v-html="field.after_content"/>
      </template>
    </nxt-core-html-content>
  </nxt-core-card>
</template>

<script>
import { mapState } from 'pinia';
import { usePartnerStore } from '../../../store/partnerStore.ts';

export default {
  nameClassStyle: 'minarm-rights',
  name: 'MinarmRights',
  props: {
    field: Object,
  },
  computed: {
    ...mapState(usePartnerStore, ['minarmRights']),
    contentMinarmRights() {
      const values = this.minarmRights || {
        verify_plafond_price: 0,
        verify_plafond_vol: 0,
      };
      this.field.value = values;
      return [{
        title: this.$t('minarmRights.priceLimit'),
        value: this.$filters.format.convertToInteger(values.verify_plafond_price, '€'),
        modifiers: '--margin-left-none',
      }, {
        title: this.$t('minarmRights.volumeLimit'),
        value: `${values.verify_plafond_vol} m³`,
        modifiers: '--margin-right-none --margin-top',
      }];
    },
  }
};
</script>

<style lang="scss" scoped>
.#{$prefixName}minarm-rights {

  &__main {
    margin: auto;
    padding: 20px;
    max-width: 900px;
    @include breakpoint(tablet) {
      display: flex;
      flex-flow: wrap;
      justify-content: center;
      max-width: 100%;
    }
  }

  &__card {
    max-width: 250px;
    width: 100%;
    margin: auto;
    border-radius: var(--nxt-border-radius-base);
    background-color: #253163;

    &.--margin-top {
      margin-top: var(--nxt-space-default);
    }

    @include breakpoint(tablet) {
      width: 250px;
      &.--margin-top {
        margin-top: 0;
      }
    }

    :deep(.el-card__body) {
      font-size: var(--nxt-font-size-xlarge);
      font-weight: 200;
      text-align: center;
    }

    &__content {
      font-weight: var(--nxt-font-weight-bold);
      padding: var(--nxt-space-small) var(--nxt-space-xsmall);
      text-align: center;

      &__title {
        text-align: center;
        text-transform: uppercase;
        color: var(--nxt-color-white);
        font-size: 14px;
        margin: var(--nxt-space-small);
      }

      &__price {
        text-align: center;
        color: var(--nxt-color-primary);
        white-space: normal;
        margin: var(--nxt-space-small);
        font-size: 30px;
      }
    }
  }
}
</style>
